import { useTranslation } from "react-i18next";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@dosa/ui";

const questions = ["q1", "q2", "q3", "q4"] as const;

export function FaqPage() {
  const { t } = useTranslation();
  return (
    <div className="container-app py-16 lg:py-20">
      <h1 className="text-4xl font-semibold tracking-[-0.02em] text-charcoal-900">{t("faq.title")}</h1>

      <Accordion className="mt-10 max-w-3xl rounded-lg border border-charcoal-100 bg-surface px-5 shadow-card">
        {questions.map((q) => (
          <AccordionItem key={q} value={q}>
            <AccordionTrigger>{t(`faq.${q}.q`)}</AccordionTrigger>
            <AccordionContent>{t(`faq.${q}.a`)}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
